/**
 * EAA-1694: OIDC runtime config for apps/editor.
 *
 * Sourced from Vite env vars, matching web-content's existing pattern (`authConfig.ts`
 * there) rather than portal's fetched `/config.json` — the editor has no runtime-config
 * bootstrap, and introducing a second config mechanism for one app is not worth it.
 * Defaults point at the shared local Keycloak realm so `pnpm dev` works unconfigured.
 */
export interface EditorAuthRuntimeConfig {
    authority: string;
    clientId: string;
    /**
     * EAA-1765: the portal is the single visible login entry across the suite, so an
     * unauthenticated user is bounced to `${portalUrl}/login?returnTo=<deep link>`
     * rather than straight to Keycloak.
     */
    portalUrl: string;
    /**
     * `token` keeps the editor on its historical auth: an API token pasted by hand into
     * `localStorage.editor_upload_api_token`. That path is NOT removed — the editor is
     * also run standalone against environments with no Keycloak, and embed/player routes
     * never had an interactive session at all. `sso` is the default because that is where
     * the platform is going; flip to `token` per environment via `VITE_AUTH_MODE`.
     */
    mode: 'sso' | 'token';
}

export const authConfig: EditorAuthRuntimeConfig = {
    authority: import.meta.env.VITE_OIDC_AUTHORITY || 'http://localhost:8081/realms/emg',
    clientId: import.meta.env.VITE_OIDC_CLIENT_ID || 'editor',
    portalUrl: import.meta.env.VITE_PORTAL_URL || 'http://localhost:3002',
    mode: import.meta.env.VITE_AUTH_MODE === 'token' ? 'token' : 'sso',
};

/** True when the editor should drive an interactive SSO session. */
export const usesSso = authConfig.mode === 'sso';
